import { getDb, type SkimReportRecord } from './db';

export async function findByHash(hash: string): Promise<SkimReportRecord | undefined> {
  const db = await getDb();
  return db.getFromIndex('skim_reports', 'by_manuscript_hash', hash);
}

export async function getById(id: string): Promise<SkimReportRecord | undefined> {
  const db = await getDb();
  return db.get('skim_reports', id);
}

export async function upsert(record: SkimReportRecord): Promise<void> {
  const db = await getDb();
  await db.put('skim_reports', record);
}

export async function patch(id: string, changes: Partial<SkimReportRecord>): Promise<SkimReportRecord | undefined> {
  const db = await getDb();
  const existing = await db.get('skim_reports', id);
  if (!existing) return undefined;
  const next: SkimReportRecord = { ...existing, ...changes, updatedAt: Date.now() };
  await db.put('skim_reports', next);
  return next;
}

export function newId(): string {
  return crypto.randomUUID();
}

export function makeReport(args: {
  manuscriptHash: string;
  manuscriptTitle: string;
  studyType?: string;
  guidelineApplied?: string;
}): SkimReportRecord {
  const now = Date.now();
  return {
    id: newId(),
    manuscriptHash: args.manuscriptHash,
    manuscriptTitle: args.manuscriptTitle,
    studyType: args.studyType ?? null,
    guidelineApplied: args.guidelineApplied ?? null,
    status: 'pattern_only',
    methodologyScore: null,
    decisionRecommendation: null,
    decisionRationale: '',
    editorNotes: '',
    createdAt: now,
    updatedAt: now,
  };
}
